import {asBlob} from "html-docx-js-typescript";
import {saveAs} from "file-saver";

export function exportDocX(element: HTMLElement) {
    const stripHidden = (node: Element) => {
        for (let child of node.children) {
            if (child.classList.contains("NoExport")) {
                node.removeChild(child);
            } else {
                stripHidden(child);
            }
        }
        return node;
    };
    const exportStyles = {
        Container: "font-size:12pt",
        DialogueCue: "text-align:center;text-transform:uppercase",
        DialogueLine: "margin-left:5cm;margin-right:5cm",
        Dialogue: "margin-bottom:10px",
        GoTo: "text-align:right;margin-right:1cm",
        Interaction: "font-weight:bold;font-style:italic;color:orange",
        NoExport: "display:none",
        PageNumber: "page-break-before:always;text-align:right",
        Script: "margin-left:1cm;margin-right:1cm;margin-bottom:10px",
        Wrylie: "text-align:center"
    };
    const header = "<body style=height:297mm;width:210mm><div style=font-family:Courier;>";
    const footer = "</div></body>";
    let html = stripHidden(element.cloneNode(true) as HTMLElement).innerHTML;

    Object.entries(exportStyles).forEach(([className, style]) => {
        html = html.replaceAll(new RegExp(`class="[^"]*${className}[^"]*"`, "g"),
            `style=${style}`);
    });

    html = html.replaceAll("’", "'");

    return asBlob(header + html + footer, {
        margins: {
            left: 700,
            right: 700,
            top: 400,
            bottom: 400
        }
    }).then((blob) => saveAs(blob as Blob, "script.docx"));
}